import React, { useState, useEffect } from 'react'
import {
  Panel,
  Button,
  Input,
  ControlLabel,
  Uploader,
  Icon,
  Checkbox,
  CheckboxGroup,
  Message,
} from 'rsuite'
import { useParams, useHistory } from 'react-router-dom'
import { useForm, Controller } from 'react-hook-form'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import { startLoading, doneLoading } from '../../utils/loading'
import { isRequired, isValidators, requiredFiled } from '../../utils/ValidatorUtils'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import AttachFilesView from '../../widgets/makeContract/AttachFilesMakeContractView'
import {
  getDownloadAttachmentGrantee,
  updateSendEditContract,
  updateSendEditContractSecureApprove,
} from '../../redux/actions/contract'
import pathname from '../../constants/pathname'
import ConfirmWidget from '../../widgets/confirm/ConfirmWidget'
import ApproverList from '../../components/modal/ApproverListModal/ApproverList'
import FetchNewApprover from '../../components/modal/ApproverListModal/FetchNewApprover'
import CancelApprovalList from '../../components/modal/ApproverListModal/CancelApprovalList'
import HTMLWidget from '../HTMLWidget'
import EditButton from '../../components/buttons/editButton/EditButton'

export default function MoreRequestStaffEdit(props) {
  const {
    showCommandButton,
    schema,
    isEdit,
    onChangeIsEdit,
    onSuccess = () => {},
    isDirector,
    disableForm,
  } = props
  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [showConfirm, setShowConfirm] = useState(false)
  const [request, setRequest] = useState()
  const [contractModifyType, setContractModifyType] = useState([])
  const [sendToGranteeVal, setSendToGranteeVal] = useState(false)

  const { register, handleSubmit, errors, control, setValue, setError, clearErrors } = useForm()

  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const history = useHistory()

  const styles = {
    lineHeight: '100px',
  }

  useEffect(() => {
    if (
      schema.requestNote?.contractModifyType?.value &&
      schema.requestNote?.contractModifyType?.value.length > 0
    ) {
      setValue(
        schema.requestNote?.contractModifyType?.name,
        schema.requestNote?.contractModifyType?.value
      )
      setContractModifyType(schema.requestNote?.contractModifyType?.value)
    } else {
      schema.requestNote?.contractModifyType?.name &&
        setValue(schema.requestNote?.contractModifyType?.name)
    }
  }, [schema])

  const handleCallService = async () => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    setShowConfirm(false)
    try {
      if (isDirector) {
        const response = await updateSendEditContractSecureApprove(request, projectId)
        // console.log('response isDirector', response)

        if (response.success) {
          if (response.secureApprovalUri) {
            setIsError(false)
            doneLoading()
            setIsLoading(false)
            window.location.href = response.secureApprovalUri
          } else {
            setIsLoading(false)
            doneLoading()
            return history.push(`${pathname.proposal.overview.overviewCoworker}`)
          }
        } else {
          setIsError(response.error)
        }
      } else {
        const response = await updateSendEditContract(request, projectId)
        console.log('response', response)

        if (response) {
          setIsLoading(false)
          doneLoading()
          return history.push(`${pathname.proposal.overview.overviewCoworker}`)
        }
      }
    } catch (e) {
      console.log('e', e)
      setIsError(e?.response?.data?.errorMessage || 'ไม่สำเร็จ โปรดติดต่อผู้ดูแลระบบ')
    }
    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    console.log('data', data)

    let request = {
      projectVersionId: projectId,
      userId: '',
      value: data.note,
      contractModifyType: data.contractModifyType || [],
      isCriticalImpacted: false, //always false
      // isCriticalImpacted: isDirector
      //   ? schema.requestNote.isCriticalImpacted.value
      //   : data.IsCriticalImpacted,
      sendToGrantee: sendToGranteeVal,
      noteSendToGrantee: data?.note || '',
    }

    // console.log('request', request)

    setRequest(request)
    setShowConfirm(true)

    //handleCallService(request)
  }

  const onDownload = async (fileObj) => {
    startLoading()
    var file = await getDownloadAttachmentGrantee(projectId, fileObj.id)
    // var file = []

    const url = window.URL.createObjectURL(new Blob([file], { type: file.type }))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', fileObj.name)
    document.body.appendChild(link)
    link.click()
    doneLoading()
  }

  const onPreview = async (fileObj) => {
    startLoading()
    var file = await getDownloadAttachmentGrantee(projectId, fileObj.id)
    // var file = []

    const url = window.URL.createObjectURL(new Blob([file], { type: file.type }))
    const link = document.createElement('a')
    link.href = url
    link.target = '_blank'
    link.setAttribute('value', fileObj.name)
    document.body.appendChild(link)
    link.click()
    doneLoading()
  }

  return (
    <div>
      {schema?.requestNote ? (
        <Panel
          header={schema.requestNote.header}
          collapsible
          defaultExpanded
          bordered
          shaded
          style={{ marginTop: 20 }}
        >
          {/* {schema?.requestNote?.isCriticalImpacted &&
          schema.requestNote.isCriticalImpacted.readonly ? (
            schema.requestNote.isCriticalImpacted.value && (
              <Message
                showIcon
                type="warning"
                description={schema.requestNote.isCriticalImpacted.label}
              />
            )
          ) : (
            <Controller
              key={schema.requestNote.isCriticalImpacted.name}
              name={schema.requestNote.isCriticalImpacted.name}
              control={control}
              defaultValue={schema.requestNote.isCriticalImpacted.value}
              render={(props) => {
                return (
                  <Checkbox
                    name={schema.requestNote.isCriticalImpacted.name}
                    value={schema.requestNote.isCriticalImpacted.value}
                    onChange={(value, checked) =>
                      setValue(schema.requestNote.isCriticalImpacted.name, checked)
                    }
                    disabled={schema.requestNote.isCriticalImpacted.disabled}
                  >
                    {schema.requestNote.isCriticalImpacted.label}
                  </Checkbox>
                )
              }}
            />
          )}
          <br /> */}
          <ControlLabel>{schema.attachments.header}</ControlLabel>
          <AttachFilesView
            schema={schema.attachments.attachFiles}
            onDownload={onDownload}
            onPreview={onPreview}
          />
          {schema.requestNote.contractModifyType && !sendToGranteeVal && (
            <>
              <ControlLabel>
                {requiredFiled(
                  schema.requestNote.contractModifyType.validators,
                  schema.requestNote.contractModifyType.label
                )}
              </ControlLabel>
              {errors[schema.requestNote.contractModifyType.name] && (
                <Message
                  showIcon
                  type="error"
                  description={errors[schema.requestNote.contractModifyType.name].message}
                />
              )}

              {!disableForm ? (
                <Controller
                  key={schema.requestNote.contractModifyType.name}
                  name={schema.requestNote.contractModifyType.name}
                  control={control}
                  defaultValue={contractModifyType}
                  rules={isValidators(
                    !sendToGranteeVal ? schema.requestNote.contractModifyType.validators : null
                  )}
                  render={(props) => {
                    return (
                      <CheckboxGroup
                        name={schema.requestNote.contractModifyType.name}
                        value={contractModifyType}
                        onChange={(value, checked) => {
                          console.log('contractModifyType==>', value)

                          if (value.length > 0) {
                            setValue(schema.requestNote.contractModifyType.name, value)
                          } else {
                            setValue(schema.requestNote.contractModifyType.name)
                          }
                          setContractModifyType(value)
                        }}
                      >
                        {schema.requestNote.contractModifyType.options.map((item, index) => {
                          return (
                            <Checkbox
                              value={item.value}
                              disabled={isDirector ? true : item.disabled}
                              key={index}
                            >
                              {item.label}
                            </Checkbox>
                          )
                        })}
                      </CheckboxGroup>
                    )
                  }}
                />
              ) : (
                <CheckboxGroup
                  name={schema.requestNote.contractModifyType.name}
                  value={contractModifyType}
                >
                  {schema.requestNote.contractModifyType.options.map((item, index) => {
                    return (
                      <Checkbox
                        value={item.value}
                        //disabled={true}
                        key={index}
                      >
                        {item.label}
                      </Checkbox>
                    )
                  })}
                </CheckboxGroup>
              )}
            </>
          )}
          {schema?.requestNote?.approveComments?.length > 0 &&
            schema?.requestNote?.approveComments?.map((item, index) => {
              return (
                <Message
                  key={index}
                  type={'info'}
                  description={
                    <div>
                      {item.label}
                      <div style={{ marginLeft: 20 }}>
                        <HTMLWidget data={item.value || 'ไม่ระบุ'} />
                      </div>
                    </div>
                  }
                />
              )
            })}
          {schema?.requestNote?.note && (
            <>
              <br />
              <ControlLabel>
                {requiredFiled(schema.requestNote.note.validators, schema.requestNote.note.label)}
              </ControlLabel>

              {!disableForm ? (
                <>
                  <Checkbox
                    defaultChecked={schema?.sendToGrantee?.value || sendToGranteeVal}
                    onChange={(_, checked, e) => {
                      console.log('checked ', checked)
                      setSendToGranteeVal(checked)
                    }}
                  >
                    {schema?.requestNote?.sendToGrantee?.label}
                  </Checkbox>

                  <ErrorMessage error={errors[schema.requestNote.note.name]} />
                  <Input
                    name={schema.requestNote.note.name}
                    inputRef={register(isValidators(schema.requestNote.note.validators))}
                    rows={3}
                    placeholder={schema.requestNote.note.hint}
                    componentClass="textarea"
                    style={{ marginTop: 5 }}
                    defaultValue={schema.requestNote.note.value}
                    disabled={schema.requestNote.note.disabled}
                  />
                </>
              ) : (
                <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{schema.requestNote.note.value}</p>
              )}
            </>
          )}
          <hr />
          {isError && <Message showIcon type="error" description={isError} />}
          {schema?.requestNote?.budgetMessage && (
            <Message showIcon type="error" description={schema?.requestNote?.budgetMessage} />
          )}
          {!disableForm ? (
            <>
              {sendToGranteeVal ? (
                <EditButton
                  icon="send"
                  onClick={handleSubmit(onSubmit)}
                  disabled={schema.requestNote.note.disabled}
                  children={
                    schema?.requestNote?.sendToGrantee?.buttonText || 'ส่งกลับให้ผู้รับทุนแก้ไข'
                  }
                />
              ) : !isDirector ? (
                <ApproverList
                  approveType={5}
                  projectversionId={projectId}
                  style={{ marginLeft: 10 }}
                  buttontext={'ตรวจสอบสายอนุมัติและ' + schema.requestNote.buttonText}
                  contractModifyType={contractModifyType}
                  isLoading={isLoading}
                  fetchButton={(disabled) => (
                    <SaveButton
                      icon="send"
                      onClick={handleSubmit(onSubmit)}
                      disabled={
                        (sendToGranteeVal ? false : schema?.requestNote?.budgetMessage) ||
                        schema.requestNote.note.disabled ||
                        disabled
                      }
                      children={
                        sendToGranteeVal
                          ? schema?.requestNote?.sendToGrantee?.buttonText ||
                            'ส่งกลับให้ผู้รับทุนแก้ไข'
                          : schema.requestNote.buttonText
                      }
                    />
                  )}
                />
              ) : (
                <SaveButton
                  onClick={handleSubmit(onSubmit)}
                  disabled={
                    (sendToGranteeVal ? false : schema?.requestNote?.budgetMessage) ||
                    schema.requestNote.note.disabled
                  }
                  children={
                    sendToGranteeVal
                      ? schema?.requestNote?.sendToGrantee?.buttonText || 'ส่งกลับให้ผู้รับทุนแก้ไข'
                      : schema.requestNote.buttonText
                  }
                />
              )}
            </>
          ) : (
            <>
              {schema.checkButton && (
                <ApproverList
                  approveType={5}
                  projectversionId={projectId}
                  style={{ marginLeft: 10 }}
                  buttontext={schema.CheckButton}
                  contractModifyType={contractModifyType}
                  isLoading={isLoading}
                  fetchButton={(disabled) =>
                    schema.fetchButton && (
                      <FetchNewApprover
                        approveType={5}
                        projectversionId={projectId}
                        style={{ marginRight: 10, marginBottom: 10 }}
                        buttontext={schema?.FetchButton}
                        onSuccess={onSuccess}
                        disabled={disabled}
                      />
                    )
                  }
                />
              )}

              {schema.cancelButton && (
                <CancelApprovalList
                  approveType={5}
                  projectversionId={projectId}
                  style={{ marginRight: 10, marginLeft: 10 }}
                  buttontext={schema.CancelButton}
                  onSuccess={onSuccess}
                />
              )}
            </>
          )}
        </Panel>
      ) : (
        <>
          <Panel
            header={schema.attachments.header}
            collapsible
            defaultExpanded
            bordered
            shaded
            style={{ marginTop: 20 }}
          >
            <AttachFilesView
              schema={schema.attachments.attachFiles}
              onDownload={onDownload}
              onPreview={onPreview}
            />
          </Panel>
        </>
      )}
      <br />
      {schema?.requestNote && (
        <ConfirmWidget
          size={'sm'}
          title={`ยืนยันการ${
            sendToGranteeVal
              ? schema?.requestNote?.sendToGrantee?.buttonText || 'ส่งกลับให้ผู้รับทุนแก้ไข'
              : schema.requestNote.buttonText
          }`}
          show={showConfirm}
          detail={`กรุณายืนยันการ${
            sendToGranteeVal
              ? schema?.requestNote?.sendToGrantee?.buttonText || 'ส่งกลับให้ผู้รับทุนแก้ไข'
              : schema.requestNote.buttonText
          }`}
          onCancle={() => setShowConfirm(false)}
          onConfirm={() => handleCallService()}
        />
      )}
    </div>
  )
}
